import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const processSchema: CollectionCreateSchema = {
  name: CollectionName.Process,
  enable_nested_fields: true,
  fields: [
    {
      name: "id",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "process_code",
      type: "string",
      sort: true,
      infix: true,
    },
    {
      name: "process_name",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "un_code",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "most_common",
      type: "bool",
      optional: true,
      sort: true,
    },
    {
      name: "ranking",
      type: "int32",
      optional: true,
      sort: true,
    },
    {
      name: "commodity_ap",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "commodity_phyto",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
    {
      name: "active",
      type: "bool",
      sort: true,
    },
    {
      name: "updated_at",
      type: "int64",
      sort: true,
      infix: true,
    },
    {
      name: "updated_by",
      type: "string",
      optional: true,
      sort: true,
      infix: true,
    },
  ],
  visibility: CollectionVisibility.Public,
}
